/* Mint-Invoice › drawer "Lập hoá đơn". Màu chỉ var(--…). */
.dr { display: flex; flex-direction: column; gap: 20px; }
.pill { align-self: flex-start; padding: 3px 9px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); background: var(--ok-bg); color: var(--ok); }
.h { font-size: 14px; font-weight: 600; }
.grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 14px; margin-top: 12px; }
.span2 { grid-column: span 2; }
.mstRow { display: flex; gap: 6px; align-items: flex-end; }
.mstRow > :first-child { flex: 1; min-width: 0; }
.ok { margin-top: 5px; font-size: 12px; color: var(--ok); }
.lb { font-size: 12px; color: var(--lb); }
.mstRow + .lb { margin-top: 5px; }
.err { font-size: 12px; color: var(--err); }
.warn { font-size: 12px; color: var(--warn); }
.sec { padding-top: 14px; border-top: 1px solid var(--line); }
.col { display: flex; flex-direction: column; gap: 10px; }
.between { display: flex; justify-content: space-between; align-items: baseline; }
.tbl { margin-top: 10px; border-radius: 12px; box-shadow: inset 0 0 0 1px var(--bd); overflow: hidden; }
.tr { display: grid; grid-template-columns: 70px 1fr 64px 92px 66px 110px; gap: 8px; align-items: center; min-height: 40px; padding: 0 12px; border-top: 1px solid var(--line); }
.tr b { font-weight: var(--fw-label); }
.th { min-height: 0; padding: 8px 12px; border-top: 0; background: var(--sub); font-size: 12px; color: var(--lb); }
.r { text-align: right; }
.cut { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.vat { justify-self: end; display: inline-flex; align-items: center; gap: 4px; padding: 2px 7px; border-radius: 999px; background: var(--ctl); font-size: 12px; font-weight: var(--fw-label); }
.vat svg { color: var(--lb); }
.warnBox { margin-top: 8px; padding: 10px 12px; border-radius: 10px; background: var(--warn-bg); color: var(--warn); font-size: 12px; }
.chH { margin-top: 12px; font-weight: var(--fw-label); }
.chRow { margin-top: 6px; display: flex; justify-content: space-between; padding: 10px 12px; border-radius: 10px; background: var(--sub); }
.chRow b { font-weight: var(--fw-label); }
.fxRow { display: flex; align-items: center; gap: 12px; margin-top: 10px; }
.fx { display: flex; align-items: center; height: 40px; border-radius: 10px; border: 1px solid var(--bd); overflow: hidden; }
.fxLow { border-color: var(--warn); }
.fx button { display: flex; align-items: center; justify-content: center; width: 40px; height: 100%; border: 0; background: var(--sub); color: var(--tx); cursor: pointer; }
.fx span { width: 110px; text-align: center; font-weight: var(--fw-label); }
.checks { padding: 4px 12px; border-radius: 12px; background: var(--sub); }
.chk { display: flex; align-items: center; gap: 10px; min-height: 32px; }
.chk + .chk { border-top: 1px solid var(--line); }
.grow { flex-grow: 1; }
.mOk, .mErr { width: 18px; height: 18px; flex-shrink: 0; border-radius: 50%; color: var(--card); font-size: 11px; font-weight: 600; display: flex; align-items: center; justify-content: center; }
.mOk { background: var(--ok); }
.mErr { background: var(--err); }
.errBox { padding: 10px 12px; border-radius: 10px; background: var(--err-bg); color: var(--err); font-size: 12px; font-weight: var(--fw-label); }
.chkL { display: flex; align-items: center; gap: 10px; cursor: pointer; }
.chkL input { width: 16px; height: 16px; margin: 0; accent-color: var(--pri); }
.tot { flex-grow: 1; }
.tot b { font-size: 18px; font-weight: 600; }
